/** Interface languages with a translation bundle in `resources/js/translations`. */
export const SUPPORTED_LOCALES = [
    'de',
    'en',
    'es',
    'fr',
    'it',
] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

export const DEFAULT_LOCALE: SupportedLocale = 'en';

const isSupported = (value: string): value is SupportedLocale => {
    return (SUPPORTED_LOCALES as readonly string[]).includes(value);
};

/**
 * Pick the interface language for a visitor who is not logged in from the
 * browser's preference list (`navigator.languages`), in order. Region tags
 * such as `es-MX` or `de_AT` fall back to their base language; anything
 * unsupported is skipped and English is the last resort.
 */
export function detectBrowserLocale(candidates: readonly (string | undefined | null)[]): SupportedLocale {
    for (const candidate of candidates) {
        const base = (candidate ?? '').trim().toLowerCase().split(/[-_]/)[0];

        if (base && isSupported(base)) {
            return base;
        }
    }

    return DEFAULT_LOCALE;
}
